import {
    SET_GEBRUIKERS,
    ADD_GEBRUIKERS,
    GEBRUIKER_ERROR,
    SET_GEBRUIKER,
    UPDATE_GEBRUIKER_IN_LIST
  } from './actions';
  export default function cats(state = {
    item: [],
    items: []
  }, action = {}) {
    switch (action.type) {
      case ADD_GEBRUIKERS:
        return { ...state,
          items: [...state.itens, action.results]
        };
      case SET_GEBRUIKER:
        return { ...state,
          item: action.results
        };
      case GEBRUIKER_ERROR:
        return { ...state,
          error: action.payload
        };
      case SET_GEBRUIKERS:
        return { ...state,
          items: action.results
        };
      case UPDATE_GEBRUIKER_IN_LIST:
        return { ...state,
          items: state.items.map(user =>
            user._id === action.id
              ? { ...user, ...action.updatedData }
              : user
          )
        };
      default:
        return state;
    }
  }
  